import type { SxProps, Theme } from '@mui/material/styles';

type NewHomepageSx = SxProps<Theme>;

export const newHomepageTypography = {
  sectionLabel: {
    color: 'brand.bodyText',
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.2,
    textAlign: 'center',
  } satisfies NewHomepageSx,
  h1: {
    fontSize: { xs: 36, md: 64 },
    lineHeight: 1.2,
    fontWeight: 800,
    letterSpacing: 0,
  } satisfies NewHomepageSx,
  h2: {
    fontSize: { xs: 32, md: 48 },
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.03em',
  } satisfies NewHomepageSx,
  h4: {
    fontSize: { xs: 20, md: 24 },
    fontWeight: 700,
    lineHeight: 1.3,
  } satisfies NewHomepageSx,
  h4Tight: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 1.2,
  } satisfies NewHomepageSx,
  body16: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.4,
  } satisfies NewHomepageSx,
  meta14: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.4,
  } satisfies NewHomepageSx,
} as const;
